	<h2 mat-dialog-title class="default-dialog-header pt-4">Special Hours</h2>

	<mat-dialog-content>
		<div class="special-hours-sub-header pt-2">Special Hours Details</div>
		<mat-form-field appearance="fill" class="w-full p-2">
			<mat-label>Special hours description</mat-label>
			<input
				matInput
				placeholder="E.g Chinese New Year"
				[formControl]="descriptionControl"
			/>
			<mat-error
				*ngIf="descriptionControl.invalid && descriptionControl.touched"
			>
				Description is required
			</mat-error>
		</mat-form-field>
		<div class="flex justify-content-between flex-wrap">
			<mat-form-field class="half-width">
				<mat-label>Start Date</mat-label>
				<input
					matInput
					[matDatepicker]="startDatePicker"
					placeholder="Select Date"
					[formControl]="startDateControl"
					[matDatepickerFilter]="startDateFilter"
				/>
				<mat-datepicker-toggle matIconSuffix [for]="startDatePicker">
				</mat-datepicker-toggle>
				<mat-datepicker #startDatePicker></mat-datepicker>
				<mat-error *ngIf="startDateControl.invalid && startDateControl.touched">
					Start date is required or conflicts with existing special hours
				</mat-error>
				<mat-error *ngIf="hasDateOverlap() && startDateControl.touched && endDateControl.touched">
					Overlapping date is not allowed
				</mat-error>
			</mat-form-field>
			<mat-form-field class="half-width">
				<mat-label>End Date</mat-label>
				<input
					matInput
					[matDatepicker]="endDatePicker"
					placeholder="Select Date"
					[formControl]="endDateControl"
					[matDatepickerFilter]="endDateFilter"
					[disabled]="!startDateControl.value"
				/>
				<mat-datepicker-toggle matIconSuffix [for]="endDatePicker" [disabled]="!startDateControl.value">
				</mat-datepicker-toggle>
				<mat-datepicker #endDatePicker></mat-datepicker>
				<mat-error *ngIf="endDateControl.invalid && endDateControl.touched">
					End date is required, must be after start date, or conflicts with existing special hours
				</mat-error>
				<mat-error *ngIf="hasDateOverlap() && startDateControl.touched && endDateControl.touched">
					Overlapping date is not allowed
				</mat-error>
			</mat-form-field>
		</div>

		<!-- Date Overlap Error Message -->
		<div *ngIf="hasDateOverlap() && startDateControl.touched && endDateControl.touched" 
		     class="date-overlap-error mt-3 p-3">
			<mat-icon color="warn" class="error-icon">error</mat-icon>
			<span class="error-text">Overlapping date is not allowed. Please select a different date range.</span>
		</div>

		<mat-divider class="mt-4"> </mat-divider>

		<div class="special-hours-sub-header pt-4">Availability</div>
		<div
			class="flex justify-content-start flex-wrap mt-3 gap-3 align-items-center"
		>
			<mat-slide-toggle [formControl]="availabilityControl"
				>{{ availabilityControl.value ? 'Open' : 'Closed' }}</mat-slide-toggle
			>
			<mat-divider [vertical]="true" style="height: 40px; width: 2px">
			</mat-divider>
			<mat-checkbox 
				[formControl]="open24hrsControl"
				[disabled]="!availabilityControl.value"
			>24 hrs</mat-checkbox>
		</div>
		<!-- Time Ranges Section - Only show when availability is true and not 24hrs -->
		<div *ngIf="availabilityControl.value">
			<div class="special-hours-sub-header pt-3" *ngIf="!open24hrsControl.value">Select Store Hours</div>

			<div *ngIf="!open24hrsControl.value">
			<div
				*ngFor="let timeRange of timeRanges; let i = index"
				class="time-range-container"
			>
			<div
				class="flex justify-content-start flex-wrap gap-3 align-items-center mt-4"
			>
				<!-- Start Time -->
				<div class="time-group">
					<mat-form-field
						appearance="outline"
						class="time-formfield"
						subscriptSizing="dynamic"
					>
						<mat-label>Start Time</mat-label>
						<mat-select
							[value]="timeRange.startTime"
							(selectionChange)="onStartTimeChange(i, $event.value)"
						>
							<mat-option *ngFor="let time of getStartTimeOptions(i)" [value]="time.value">
								{{ time.display }}
							</mat-option>
						</mat-select>
						<mat-icon matSuffix>schedule</mat-icon>
					</mat-form-field>
				</div>

				<!-- Separator -->
				<div class="time-separator">-</div>

				<!-- End Time -->
				<div class="time-group">
					<mat-form-field
						appearance="outline"
						class="time-formfield"
						subscriptSizing="dynamic"
					>
						<mat-label>End Time</mat-label>
						<mat-select
							[value]="timeRange.endTime"
							(selectionChange)="onEndTimeChange(i, $event.value)"
						>
							<mat-option *ngFor="let time of getEndTimeOptions(i)" [value]="time.value">
								{{ time.display }}
							</mat-option>
						</mat-select>
						<mat-icon matSuffix>schedule</mat-icon>
					</mat-form-field>
				</div>

				<!-- Remove Button -->
				<button
					*ngIf="i !== timeRanges.length - 1"
					mat-mini-fab
					color="warn"
					class="remove-time-button"
					(click)="removeTimeRange(i)"
				>
					<mat-icon>remove</mat-icon>
				</button>

				<!-- Add Button -->
				<button
					*ngIf="i === timeRanges.length - 1"
					mat-mini-fab
					color="primary"
					class="add-time-button"
					(click)="addTimeRange()"
				>
					<mat-icon>add</mat-icon>
				</button>
			</div>

			<!-- Validation Error Messages -->
			<div *ngIf="timeRange.startTime && timeRange.endTime && isEndTimeInvalid(i)" 
				 class="error-message mt-2">
				<mat-icon color="warn" class="error-icon">error</mat-icon>
				<span>End time must be after start time</span>
			</div>
		</div>
		</div>

		<!-- Internal Time Overlap Warning -->
		<div *ngIf="hasInternalTimeOverlaps()" class="error-message mt-3">
			<mat-icon color="warn" class="error-icon">error</mat-icon>
			<span>Time ranges cannot overlap with each other</span>
		</div>
		</div>
	</mat-dialog-content>
	<mat-dialog-actions align="end">
		<button mat-button color="warn" (click)="cancel()">Discard</button>
		<button
			mat-flat-button
			color="primary"
			(click)="saveSpecialHours()"
			[disabled]="specialHoursForm.invalid || hasInvalidTimeRanges() || hasInternalTimeOverlaps() || hasDateOverlap()"
			[title]="specialHoursForm.invalid ? 'Please fill in all required fields' : hasInvalidTimeRanges() ? 'End time must be after start time' : hasInternalTimeOverlaps() ? 'Cannot save due to overlapping time ranges' : hasDateOverlap() ? 'Overlapping date is not allowed' : ''"
		>
			Save
		</button>
	</mat-dialog-actions>
